module.exports = __webpack_public_path__ + "static/media/Verification-graphics.121184a0.png";